module.exports = __webpack_public_path__ + "img/prometheus.b1fab729.svg";